import mutations from './mutations'
import getters from './getters'
import state from './state'
import actions from './actions'

export default {
  mutations,
  getters,
  state,
  actions,
  namespaced: true,
}
